import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import GoogleApiWrapper from 'components/GoogleMaps/lib/GoogleApiWrapper'
import LoadingSpinner from 'components/icons/LoadingSpinner'

import GoogleMap from './GoogleMap'

// to do, validate that 'arrive' attribute of event is a valid date?

class Map extends Component {
  static propTypes = {
    events: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
        arrive: PropTypes.string,
      })
    ),
    currentEventId: PropTypes.string,
    loaded: PropTypes.bool.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    style: PropTypes.object,
  }

  static defaultProps = {
    events: [],
    currentEventId: undefined,
    style: {
      width: '100%',
      height: '280px',
    },
  }

  render() {
    if (!this.props.loaded) {
      return (
        <LoadingSpinner
          width="50px"
          fill="rgba(255, 255, 255, 0.8)"
          backgroundFill="rgba(232, 105, 27, 0.8)"
        />
      )
    }

    const { events, currentEventId } = this.props
    // add departure dates and duration
    // TODO: add count for locations visited more than once
    const markerData = []
    events.forEach((event, index) => {
      markerData.push({
        ...event,
        isCurrent: !!(event.id === currentEventId)
      })
      // set the 'depart' date on the previous event based on this 'arrive' date
      // ignore the first two items as our 'start' does not need a duration
      if (index > 1 && event.arrive) {
        const previousEvent = markerData[index - 1]
        previousEvent.depart = event.arrive
        // add duration
        previousEvent.duration = {
          days:
            moment(previousEvent.depart).diff(
              moment(previousEvent.arrive),
              'days'
            ) + 1,
        }
      }
    })

    return (
      <div style={this.props.style}>
        <GoogleMap {...this.props} markers={markerData} />
      </div>
    )
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyAS6CRIG3j--aBkQJA3pS01OboxE6wNpr4',
})(Map)



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/Map/index.js